<script setup>
import { SelectGroup, } from 'radix-vue';
import { computed, } from 'vue';
import { cn, } from '@/utils/ShadcnUtil';

const props = defineProps({
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
});

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});
</script>

<template>
  <SelectGroup
    :class="cn('p-1 w-full', props.class)"
    v-bind="delegatedProps"
  >
    <slot />
  </SelectGroup>
</template>
